.mainContentSection {
  background-color: white;
}

.contentSection {
  width: 100%;
  max-width: 1100px;
}

.heading {
  font-size: 32px;
  color: #3caeb0;
  font-weight: bold;
  line-height: 1.1em;
}

.subsectionHeading {
  color: #3caeb0;
  font-size: 24px;
  line-height: 1.1em;
  font-weight: 700;
}

.subheading {
  color: #3caeb0;
  font-size: 20px;
  line-height: 1.1em;
  font-weight: 600;
}

.content {
  line-height: 1.55em;
  letter-spacing: normal;
  text-wrap: pretty;
}

.form {
  padding: 48px 0;
}

@media (min-width: 768px) {
  .heading {
    font-size: 50px;
  }

  .subsectionHeading {
    font-size: 35px;
  }

  .subheading {
    font-size: 24px;
  }

  .form {
    padding: 96px 20px;
  }
}
